export default __webpack_public_path__ + "static/media/footer.6c98e101.svg";